// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /strips/results-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeStripsResultsGetBody,
  typeStripsResultsGetOutput200,
} from "../../sdk/strips/postStripsResultsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildStripsResultsGetQueryKey(
  payload: typeStripsResultsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  if (typeof payload.eventId !== "undefined") {
    queryKeySegments.push(`eventId:${JSON.stringify(payload.eventId)}`);
  }
  if (typeof payload.userIds !== "undefined") {
    queryKeySegments.push(`userIds:${JSON.stringify(payload.userIds)}`);
  }
  if (typeof payload.stripNumber !== "undefined") {
    queryKeySegments.push(`stripNumber:${JSON.stringify(payload.stripNumber)}`);
  }
  return [
    "post:strips:stripsResultsGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeStripsResultsGetOutput200,
    unknown,
    typeStripsResultsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useStripsResultsGet(
  payload: typeStripsResultsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildStripsResultsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postStripsResultsGet(payload),
    ...resolvedOptions,
  });
}
